import dayjs from 'dayjs'

import type { OsItensTypes } from '../../../../../../../services/Laboratorio'
import {
  montarTabelaRelatorio,
  montarTotaisRelatorio,
  type ColunaRelatorio,
} from '../../../meta/relatorio'
import { statusNomes } from '.'

/** Formata uma data da OS para o PDF; vazio quando não houver. */
function formatarData(valor?: string | any): string {
  if (!valor) return ''
  const data = dayjs(valor)
  return data.isValid() ? data.format('DD/MM/YYYY') : ''
}

/**
 * Colunas do relatório de OS de SOLO.
 *
 * A propriedade É coluna: o filtro por propriedade virou opcional, então a lista
 * (e o relatório) pode misturar várias — sem a coluna não dá para saber a que
 * propriedade cada linha pertence. O subtítulo indica o escopo geral.
 */
export const COLUNAS_RELATORIO_SOLO: ColunaRelatorio<OsItensTypes>[] = [
  { titulo: 'Propriedade', valor: (os) => os?.propriedade_nome ?? '' },
  { titulo: 'Talhão', valor: (os) => os?.talhao_nome ?? '' },
  { titulo: 'Safra', valor: (os) => os?.safra_nome ?? '' },
  { titulo: 'Laboratório', valor: (os) => os?.laboratorio_nome ?? '' },
  { titulo: 'Data da O.S', valor: (os) => formatarData(os?.data) },
  { titulo: 'Data coleta', valor: (os) => formatarData(os?.data_coleta) },
  { titulo: 'Status', valor: (os) => statusNomes[os?.status] ?? '' },
]

/** Tabela principal do relatório de solo. */
export function montarRelatorioSolo(lista: OsItensTypes[]) {
  return montarTabelaRelatorio(lista, COLUNAS_RELATORIO_SOLO)
}

/** Bloco de totais do relatório de solo. */
export function montarTotaisSolo(lista: OsItensTypes[]) {
  return montarTotaisRelatorio((lista ?? []).length, 'Total OS')
}
